import { StatusPip, Tile, type StatusPipStatus } from '@diwata/ironvale'
import type { DeployItem, DeploysFeed } from '@/api/feeds'
import { relativeTime, UnavailableNote } from './shared'

const STATE_PIP: Record<DeployItem['state'], StatusPipStatus> = {
  followed: 'ok',
  stale: 'warn',
  red: 'red',
  skipped_after_red: 'red',
  skipped: 'warn',
  pending: 'warn',
  no_runs: 'unavailable',
}

const STATE_LABEL: Record<DeployItem['state'], string> = {
  followed: 'followed',
  stale: 'stale',
  red: 'red',
  skipped_after_red: 'skipped after red',
  skipped: 'skipped',
  pending: 'running',
  no_runs: 'no runs',
}

/** Recent runs on main + the follow-the-merge law. Red is loud here. */
export function DeploysTile({ feed }: { feed: DeploysFeed }) {
  const violated = feed.law?.state === 'violated'
  const status: StatusPipStatus =
    feed.status === 'unavailable' ? 'unavailable' : violated ? 'red' : 'ok'
  return (
    <Tile title="Deploys" status={status} asOf={feed.asOf}>
      {feed.status === 'unavailable' ? (
        <UnavailableNote feed={feed} />
      ) : (
        <>
          {violated && (
            <div className="ap-law-banner">
              {feed.law.violations.map((v) => (
                <div key={v}>{v}</div>
              ))}
            </div>
          )}
          {!violated && feed.latest_title && (
            <p className="ap-tile-note">follows “{feed.latest_title}”</p>
          )}
          <div className="ap-tile-rows">
            {feed.items.map((item) => (
              <a
                key={item.workflow}
                className="ap-tile-row"
                href={item.link}
                target="_blank"
                rel="noreferrer"
              >
                <StatusPip status={STATE_PIP[item.state]} label={STATE_LABEL[item.state]} />
                <span className="ap-row-name">{item.workflow}</span>
                <span className="ap-row-value">{STATE_LABEL[item.state]}</span>
                <span className="ap-row-meta ap-mono">{relativeTime(item.created_at)}</span>
              </a>
            ))}
          </div>
        </>
      )}
    </Tile>
  )
}
